const CHOSEN_KEY = "ncp.assistant.space.chosen";

/**
 * Remembers, for this tab, the space the person picked themselves ("Switch space", a `/w/{space}/…` link). The launcher adopts its first
 * room as the current space only when the current one has no room and was not picked: the server's default is merely the space of the
 * person's latest conversation, which can be one without apps.
 */
export function markSpaceChosen(key: string): void {
  try { sessionStorage.setItem(CHOSEN_KEY, key); } catch { /* storage unavailable */ }
}

export function wasSpaceChosen(key: string): boolean {
  try { return sessionStorage.getItem(CHOSEN_KEY) === key; } catch { return false; }
}
